/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Upload_CompleteInputs */



/**
* | output |
* | --- |
* | "Upload complete. Submitting job..." |
*
* @param {Ad_Upload_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_upload_complete = /** @type {((inputs?: Ad_Upload_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Upload_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléchargement terminé. Envoi de la tâche...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Upload abgeschlossen. Auftrag wird übermittelt...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento completato. Invio del lavoro in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка завершена. Отправка задания...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carga completada. Enviando trabajo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上传完成。正在提交作业……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップロード完了。ジョブを送信しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपलोड पूरा हो गया। जॉब सबमिट की जा रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Upload concluído. Enviando trabalho...")
	return /** @type {LocalizedString} */ ("Upload complete. Submitting job...")
});